import type { SVGProps } from "react";
export interface AlphabetKCircleIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function AlphabetKCircleIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: AlphabetKCircleIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M20.875 12a8.875 8.875 0 1 0-17.75 0 8.875 8.875 0 0 0 17.75 0m2.25 0c0 6.144-4.98 11.124-11.124 11.125S.875 18.145.875 12 5.856.875 12.001.875c6.143 0 11.124 4.981 11.124 11.126Z"
      />
      <path
        fill={color}
        d="M8.625 16V8a1.125 1.125 0 0 1 2.25 0v1.94l2.268-2.668a1.126 1.126 0 0 1 1.715 1.456l-2.376 2.793 3.132 3.76a1.124 1.124 0 1 1-1.729 1.44l-2.881-3.46-.129.152v2.586a1.125 1.125 0 0 1-2.25 0Z"
      />
    </svg>
  );
}
